// src/data/agreementRegistry.js - RULING 312, PHASE 1 (d): ONE PLACE THAT SAYS WHICH AGREEMENT A NAME IS.
//
// Before this file, the same question - "is this claim under the Amtrak agreement? the CSX? the D&H?" - was asked with
// its own regular expression in RuleBasisPicker.js (six of them), ruleResolver.js (six), NewClaim.js (two), QuickFile.js
// (one) and bnYardmasterClass.js (one), and NewClaim.js carried its own railroad -> agreement table (AMAP). Two of the
// copies already disagreed (the BN test in RuleBasisPicker lacked ruleResolver's "burlington northern" arm). A craft pack
// installs agreements; the screens must not name carriers. So the tests live here, once, and every screen asks this
// file. Behaviour is unchanged (phase 1, ruling 312 item 8): every pattern below is the one the screens used, in the
// order they were tried, and scripts\test-agreement-registry.mjs proves the answer for every agreement name the platform
// can put on a claim (AGREEMENT_LOOKUP and its aliases).
//
// family      - the catalogue family a screen draws rule text from (null: no catalogue - the AI-suggest fallback stays).
// basisTerm   - what the agreement calls its provisions ("Rule" or "Article"), for the picker's labels.
// The rule CATALOGUES themselves stay in their own files; a screen maps a family to the catalogue it already imports.


// The family of an agreement name as a claim carries it, or '' when no catalogue family claims it.
import { AGREEMENT_FAMILIES, PROFILE_DEFAULT_AGREEMENT } from './agreementFamiliesTable';   // section 737: the table is installation content (ruling 321)
export { AGREEMENT_FAMILIES, PROFILE_DEFAULT_AGREEMENT };

export function agreementFamily(agreementName) {
  const a = String(agreementName || '');
  if (!a) return '';
  const hit = AGREEMENT_FAMILIES.find((f) => f.test.test(a));
  return hit ? hit.family : '';
}

export function isFamily(agreementName, family) {
  return agreementFamily(agreementName) === family;
}

export function basisTermFor(agreementName) {
  const fam = agreementFamily(agreementName);
  const hit = AGREEMENT_FAMILIES.find((f) => f.family === fam);
  return hit ? hit.basisTerm : 'Rule';
}


export function profileDefaultAgreement(railroad, craft) {
  if (craft && craft !== 'Yardmaster') return '';
  return PROFILE_DEFAULT_AGREEMENT[railroad] || '';
}
